import React, { useState, useEffect, useRef, useCallback, useMemo, } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Card, Chip, IconButton, Grid, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme } from '@mui/material';
import { Menu as MenuIcon, Help as HelpIcon } from '@mui/icons-material';
import { useMaterialUIController, setMiniSidenav } from "context";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import SouthIcon from '@mui/icons-material/South';
import Banner1 from "../../../assets/images/Insights/commercial/banner11.png"
import Banner2 from "../../../assets/images/Insights/commercial/banner22.png"
import Banner3 from "../../../assets/images/Insights/commercial/banner33.png"
import Banner4 from "../../../assets/images/Insights/commercial/banner44.png"
import Banner5 from "../../../assets/images/Insights/commercial/banner55.png"
import Banner6 from "../../../assets/images/Insights/commercial/banner66.png"
import Banner7 from "../../../assets/images/Insights/commercial/banner77.png"
import Banner8 from "../../../assets/images/Insights/commercial/banner88.png"
import Banner9 from "../../../assets/images/Insights/commercial/banner99.png"
import FilterPanelContainer from "components/Filter/Filterpopup"
import datadrilldown from "assets/images/selectedicons/DataDrillDown.svg";
import drillDownArrow from "assets/images/selectedicons/DrillDownArrow.svg";
import datadrillhover from 'assets/images/selectedicons/Data Drill Down1.svg'

import PersonIcon from '@mui/icons-material/Person';

const Commercial = ({ subcategoryToken: propSubcategoryToken }) => {

    const naviagte = useNavigate();
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Below 900px
    const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Between 900px and 1200px

    // State for API data

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const header = document.querySelector('.MuiAppBar-root');
        if (header) {
            header.style.display = 'none';
        }
    }, []);

    // Toggle sidenav from the page menu icon
    const isTogglingSidenavRef = useRef(false);
    const handleToggleSidenav = useCallback(() => {
        if (isTogglingSidenavRef.current) return;
        isTogglingSidenavRef.current = true;
        // Defer to next frame to avoid blocking heavy charts paint
        requestAnimationFrame(() => {
            setMiniSidenav(dispatch, !miniSidenav);
            setTimeout(() => {
                isTogglingSidenavRef.current = false;
            }, 150);
        });
    }, [dispatch, miniSidenav]);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);
            } catch (error) {
                console.error('Failed loading static mocks or transforming data:', error);
                setError('Failed to load static mock data. Check competitive_analysis/data/allMocks.json');
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [location.search, propSubcategoryToken]);

    const mockData = [
        {
            id: "10001",
            title: "Promo and Display Tracker",
            thumbnail: Banner1,
            dataType: "External",
            numberOfTabs: 3,
            refreshFrequency: "Weekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "https://app.fabric.microsoft.com/groups/430a39ed-cee2-4e8f-a7d9-3656dd3e9c18/reports/b223ba24-e328-427a-b498-123c96acc541/4ee1cfc62dd33a18fc33?experience=fabric-developer",
            color: "#10001"
        },
        {
            id: "10002",
            title: "Open Orders",
            thumbnail: Banner2,
            dataType: "Internal",
            numberOfTabs: 16,
            refreshFrequency: "Daily",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10002"
        },
        {
            id: "10003",
            title: "CMA Tracking",
            thumbnail: Banner3,
            dataType: "External",
            numberOfTabs: 3,
            refreshFrequency: "Weekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10003"
        },
        {
            id: "10004",
            title: "FB Analytical Arena (Circana)",
            thumbnail: Banner4,
            dataType: "External",
            numberOfTabs: 9,
            refreshFrequency: "Biweekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10004"
        },
        {
            id: "10005",
            title: "Beverage Sales Presentation",
            thumbnail: Banner5,
            dataType: "Internal, External",
            numberOfTabs: 23,
            refreshFrequency: "Biweekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10005"
        },
        {
            id: "10006",
            title: "Bloom Dashboard",
            thumbnail: Banner6,
            dataType: "External",
            numberOfTabs: 24,
            refreshFrequency: "Biweekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10006"
        },
        {
            id: "10007",
            title: "AN Analytical Arena (Circana)",
            thumbnail: Banner7,
            dataType: "External",
            numberOfTabs: 8,
            refreshFrequency: "Biweekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10007"
        },
        {
            id: "10008",
            title: "Analytical Arena (SPINS)",
            thumbnail: Banner8,
            dataType: "External",
            numberOfTabs: 5,
            refreshFrequency: "Monthly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10008"
        },
        {
            id: "10009",
            title: "Active Nutrition Sales Presentation",
            thumbnail: Banner9,
            dataType: "External",
            numberOfTabs: 6,
            refreshFrequency: "Biweekly",
            lastRefreshed: "11/16/2025",
            views: "1,234",
            link: "",
            color: "#10009"
        }
    ];



    const [openFilters, setOpenFilters] = useState(false);
    const handleToggleFilters = () => {
        setOpenFilters((prev) => !prev);
    };

    // Filter state
    const [activeFilter, setActiveFilter] = useState('All');
    const [activeIdx, setActiveIdx] = React.useState(0);
    const [filterLoading, setFilterLoading] = useState(false);

    // Define filter presets for each quick filter
    const getFilterPreset = useCallback((filterName) => {
        const allCompanies = ["Nutrabolt", "Bloom"];
        const allCategories = ["Functional Beverage", "Active Nutrition"];
        const allBrands = ["C4", "Cellucor", "XTEND", "Bloom"];
        const allSubBrands = ["C4", "C4 Performance", "C4 Smart Energy", "C4 Ultimate", "XTEND", "Bloom Sparkling Energy", "Bloom Pop"];
        const allRoutes = ["Ecommerce", "Direct", "DSD"];
        const allChannels = ["Ecommerce", "Convenience Chain", "Convenience Independent", "Drug", "Food", "Multi Outlet", "Mass"];

        switch (filterName) {
            case 'All':
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": allRoutes,
                    Channel: allChannels,
                };
            case 'Internal Data':
            case 'External Data':
                // These might map to specific companies or categories - using all for now
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": allRoutes,
                    Channel: allChannels,
                };
            default:
                return null;
        }
    }, []);

    const [filterPresets, setFilterPresets] = useState(() => getFilterPreset('All'));

    // Handle filter click with full-page loader
    const handleFilterClick = (filter) => {
        if (filter === activeFilter || filterLoading) return;

        setFilterLoading(true);
        setLoading(true); // Show full-page loader

        // Simulate loading delay
        setTimeout(() => {
            const preset = getFilterPreset(filter);
            setActiveFilter(filter);

            // Set the preset - this will trigger FilterPanelContainer to apply it
            if (preset) {
                setFilterPresets(preset);
            } else {
                setFilterPresets(null);
            }

            setFilterLoading(false);
            setLoading(false); // Hide full-page loader

            // Open filter panel for "Custom" filter
            if (filter === 'Custom') {
                setOpenFilters(true);
            }
        }, 800);
    };

    // Handle filter changes from FilterPanelContainer
    const handleFiltersChange = useCallback((newFilters) => {
        // Don't check for preset match if we're already in Custom mode
        // FilterPanelContainer's isApplyingPresetRef prevents callback when applying presets
        if (activeFilter === 'Custom') return;

        // Check if the current filters match any preset
        const presetNames = ['All', 'Internal Data', 'External Data'];
        let matchedPreset = null;

        for (const presetName of presetNames) {
            const preset = getFilterPreset(presetName);
            if (preset) {
                const isMatching = Object.keys(preset).every(key => {
                    const presetValues = [...(preset[key] || [])].sort();
                    const currentValues = [...(newFilters[key] || [])].sort();
                    return presetValues.length === currentValues.length &&
                        presetValues.every((val, idx) => val === currentValues[idx]);
                });

                if (isMatching) {
                    matchedPreset = presetName;
                    break;
                }
            }
        }

        // If filters don't match any preset, switch to Custom
        if (!matchedPreset && activeFilter !== 'Custom') {
            setActiveFilter('Custom');
            setFilterPresets(null);
        }
    }, [activeFilter, getFilterPreset]);

    const RetailsDetails = () => {
        // naviagte("/network/retailers/details");

    }

    const [hover, setHover] = React.useState(false);
    return (


        <Box sx={{
            ml: 0,
            transition: "margin-left 0.25s ease",
            "& .MuiBox-root": { backgroundImage: "none" }
        }} style={{
            padding: isMobile ? '8px' : '0px 16px 0px 16px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* Loading Backdrop */}
            <Backdrop
                open={loading}
                sx={{
                    position: 'fixed',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                }}
            >
                <CircularProgress color="primary" />
            </Backdrop>
            <Box
                sx={{
                    height: {
                        xs: "calc(100dvh - 140px)", // mobile header
                        md: "calc(100vh - 64px)",  // desktop header
                    },
                    overflowY: "auto",
                    // px: isMobile ? 1 : 2,
                    pb: "100px",
                    /* smooth scrolling */
                    scrollBehavior: "smooth",
                    WebkitOverflowScrolling: "touch", // iOS momentum

                    /* hide scrollbar */
                    scrollbarWidth: "none",          // Firefox
                    msOverflowStyle: "none",         // IE / Edge
                    "&::-webkit-scrollbar": {
                        display: "none",               // Chrome / Safari
                    },
                }}
            >
                {/* Section Title: KPI's */}
                <Typography sx={{ mb: 1, mt: 3 }}>
                    <span style={{ color: '#1672B980', fontWeight: 200, fontSize: '16px' }}>Commercial Insights / </span><span style={{ fontWeight: 200, fontSize: "16px" }}>6 Results</span>
                </Typography>
                <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
                {/* Leadership card */}
                <Box sx={{ mt: 6 ,px:1}}>
                    {/* Retailer Cards */}
                    <Grid container spacing={2}>
                        {mockData.map((item) => (
                            <Grid key={item.id} item xs={12} sm={6} md={4} sx={{ paddingBottom: "30px" }}>
                                <Card
                                    sx={{
                                        background: "#fff",
                                        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
                                        position: "relative",
                                        paddingTop: "30px",
                                        minHeight: "auto",
                                        overflow: "visible",
                                        cursor: item.link ? "pointer" : "default",
                                        transition: "transform 0.2s",
                                        // transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                        willChange: "transform",
                                        backfaceVisibility: "hidden",

                                        "&:hover": {
                                            transform: "translateY(-4px)",   // no scale
                                            // boxShadow: "0px 12px 24px rgba(0,0,0,0.25)",
                                        },
                                        borderRadius: "4px !important",
                                        border: "none"
                                    }}
                                    onClick={() => {
                                        if (item.link) {
                                            window.open(item.link, "_blank");
                                        }
                                    }}
                                >
                                    {/* HEADER */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "-24px",
                                            left: "12px",
                                            right: "12px",
                                            height: "186px",
                                            // background: "#0d6efd",
                                            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
                                            borderRadius: "6px !important",
                                            display: "flex",
                                            alignItems: "center",
                                            // px: 2,
                                            background: item.name === "7-Eleven" ? "#008160" : item.name === "Walmart" ? "#007cc2" : "#fff",
                                            color: "#3ca32fff",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // px: 2,
                                            fontWeight: 600,
                                            fontSize: "16px",
                                            zIndex: 10,
                                            border: "none",
                                            overflow: "hidden"
                                        }}
                                    >
                                        {item?.thumbnail && (
                                            <img
                                                src={item.thumbnail}
                                                alt={item.title || "logo"}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover", // fills entire box
                                                    display: "block"     // prevents inline img gap
                                                }}
                                            />
                                        )}
                                    </Box>
                                    <Box sx={{ marginTop: "144px" }}>
                                        <p style={{ fontWeight: 300, textAlign: "center", fontSize: "16px", color: "rgba(17,17,17,0.5)" }}>{item.color}</p>
                                        <p style={{ fontWeight: "500", fontSize: "16px", paddingLeft: "16px", lineHeight: 1 }}>{item.title}</p>

                                        <Box
                                            sx={{
                                                width: "100%",
                                                mt: "17px",
                                                position: "relative",
                                                overflow: "visible",
                                                minHeight: "20px",
                                            }}
                                        >
                                            {/* LEFT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    left: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderLeft: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid  #a1b8c9",
                                                    borderTopLeftRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* RIGHT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    right: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderRight: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid #a1b8c9",
                                                    borderTopRightRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* Chips container */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between", zIndex: 2 }}>
                                                <Chip
                                                    label="DATA TYPE"
                                                    size="small"
                                                    sx={{
                                                        background: "#003a64",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        height: "14px",
                                                        borderTopLeftRadius: "0px",
                                                        borderTopRightRadius: "4px",
                                                        borderBottomRightRadius: "10px",
                                                        borderBottomLeftRadius: "0px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginLeft: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                                <Chip
                                                    label="NUMBER OF TABS
                                                
                                                "
                                                    size="small"
                                                    sx={{
                                                        background: "#005ba4",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        height: "14px",
                                                        borderTopLeftRadius: "4px",
                                                        borderTopRightRadius: "0px",
                                                        borderBottomRightRadius: "0px",
                                                        borderBottomLeftRadius: "10px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginRight: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        {/* TOP VALUES */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginTop: "4px",
                                                width: "100%"
                                            }}
                                        >
                                            <Typography sx={{ fontSize: "16px", marginLeft: "8px", fontWeight: 200, lineHeight: 1 }}>
                                                {item.dataType}
                                            </Typography>
                                            <Typography sx={{ fontSize: "16px", fontWeight: 200, marginRight: "8px", lineHeight: 1 }}>
                                                {item.numberOfTabs}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                mt: "19px",
                                                position: "relative",
                                                overflow: "visible",
                                                minHeight: "20px",
                                            }}
                                        >
                                            {/* LEFT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    left: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderLeft: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid  #a1b8c9",
                                                    borderTopLeftRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* RIGHT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    right: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderRight: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid #a1b8c9",
                                                    borderTopRightRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* Chips container */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between", zIndex: 2 }}>
                                                <Chip
                                                    label="REFRESH FREQUENCY"
                                                    size="small"
                                                    sx={{
                                                        background: "#005ba4",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        height: "14px",
                                                        borderTopLeftRadius: "0px",
                                                        borderTopRightRadius: "4px",
                                                        borderBottomRightRadius: "10px",
                                                        borderBottomLeftRadius: "0px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginLeft: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                                <Chip
                                                    label="LAST REFRESHED"
                                                    size="small"
                                                    sx={{
                                                        background: "#003a64",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        height: "14px",
                                                        borderTopLeftRadius: "4px",
                                                        borderTopRightRadius: "0px",
                                                        borderBottomRightRadius: "0px",
                                                        borderBottomLeftRadius: "10px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginRight: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        {/* TOP VALUES */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginTop: "4px",
                                                width: "100%"
                                            }}
                                        >
                                            <Typography sx={{ fontSize: "16px", marginLeft: "8px", fontWeight: 200, lineHeight: 1 }}>
                                                {item.refreshFrequency}
                                            </Typography>
                                            <Typography sx={{ fontSize: "16px", fontWeight: 200, marginRight: "8px", lineHeight: 1 }}>
                                                {item.lastRefreshed}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                fontSize: "14px",
                                                padding: "12px 14px",
                                                marginTop: "22px",
                                                justifyContent: "flex-end",

                                                /* remove normal border */
                                                borderTop: "none",

                                                /* custom top border with side gaps */
                                                "&::before": {
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    left: "14px",
                                                    right: "14px",
                                                    height: "1px",
                                                    backgroundColor: "rgba(17, 17, 17, 0.1)",
                                                },
                                            }}
                                        >
                                            <PersonIcon sx={{ fontSize: "11px", color: "#C7C7C7", fontWeight: 300 }} />
                                            <span style={{ color: "#C7C7C7", fontSize: "11px", fontWeight: 300 }}>{item.views} Views</span>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

            </Box>


        </Box>




    );
};
export default Commercial;